import React from 'react';
import { MousePointerClick, KeyRound, Package, Printer, Check } from 'lucide-react';

export default function WizardTimeline({ steps = ['Operação', 'PIN', 'Caixas', 'Impressão'], step = 1, operation, alunoNome }) {
  
  // Retorna um ícone específico baseado no passo atual
  const getIcon = (index, isCompleted) => {
    if (isCompleted) return <Check size={20} strokeWidth={3} />;
    switch (index) {
      case 0: return <MousePointerClick size={20} />;
      case 1: return <KeyRound size={20} />;
      case 2: return <Package size={20} />;
      case 3: return <Printer size={20} />;
      default: return <Check size={20} />;
    }
  };

  return (
    <div className="flex items-center justify-between w-full max-w-3xl mx-auto mb-24 mt-8 px-4">
      {steps.map((label, i) => {
        const isCompleted = step - 1 > i;
        const isCurrent = step - 1 === i;
        const isPending = step - 1 < i;

        return (
          <React.Fragment key={i}>
            {/* O Círculo do Passo */}
            <div className="relative flex flex-col items-center">
              <div
                className={`
                  w-12 h-12 rounded-full flex items-center justify-center border-4 z-10 transition-all duration-300
                  ${isCompleted ? 'bg-[#EAB308] border-[#EAB308] text-white shadow-md' : ''}
                  ${isCurrent ? 'bg-white border-[#EAB308] text-[#EAB308] scale-110 shadow-lg' : ''}
                  ${isPending ? 'bg-white border-gray-200 text-gray-300' : ''}
                `}
              >
                {getIcon(i, isCompleted)}
              </div>

              {/* Textos Centralizados Abaixo do Círculo */}
              <div className="absolute top-14 w-40 text-center flex flex-col items-center pt-2">
                <span className={`text-sm font-bold transition-colors duration-300 ${isCurrent ? 'text-[#EAB308]' : isCompleted ? 'text-gray-800' : 'text-gray-400'}`}>
                  {i + 1}. {label}
                </span>
                
                {/* Legendas (Entrada/Saída ou Nome do Aluno) */}
                {i === 0 && operation && (
                  <span className="text-xs text-[#EAB308] font-extrabold uppercase tracking-wider mt-1">{operation}</span>
                )}
                {i === 1 && alunoNome && (
                  <span className="text-xs text-gray-500 font-medium mt-1 truncate w-full px-2" title={alunoNome}>
                    {alunoNome.split(' ')[0]}
                  </span>
                )}
              </div>
            </div>

            {/* A Linha que conecta um passo ao outro */}
            {i < steps.length - 1 && (
              <div className="flex-1 h-1.5 mx-2 md:mx-4 rounded-full bg-gray-200 relative overflow-hidden">
                <div 
                  className={`absolute left-0 top-0 h-full bg-[#EAB308] transition-all duration-700 ease-in-out ${isCompleted ? 'w-full' : 'w-0'}`} 
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}